import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function MovieGrid({ items }: { items: Movie[] }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
      {items.map((movie, index) => (
        <MovieCard key={movie.id} movie={movie} index={index} />
      ))}
    </div>
  );
}